<div
  class="d-flex w-full"
  [ngClass]="temp1 === 'column' ? 'flex-column' : 'flex-row flex-wrap'"
  [style.margin-bottom.em]="temp2"
>
  @for (field of detailFields; track field) { @if (visible(field)) { @switch (field.type) {
  <!-- FIELD -->
  @case ('field') {
  <div
    class="detail-field detail-field--responsive"
    [style.flex-basis]="(field.fxFlex || '33') + '%'"
    [style.max-width]="temp1 === 'column' ? null : (field.fxFlex || '33') + '%'"
  >
    <span [innerText]="getLabel(field)" class="field-headline"></span>
    @if (field.break === false) {
    <span>: </span>
    } @if (field.break !== false) {
    <span><br /></span>
    }
    <span [innerText]="getData(field)" [style]="field.css" class="field-content"></span>
  </div>
  }
  <!-- ALLIGNEDFIELD -->
  @case ('allignedField') {
  <div
    class="detail-field alligned-field d-flex flex-row"
    [style.flex-basis]="(field.fxFlex || '33') + '%'"
    [style.max-width]="temp1 === 'column' ? null : (field.fxFlex || '33') + '%'"
  >
    <div class="alligned-field-cell">
      <span [innerText]="getLabel(field) + ': '" class="field-headline"></span>
    </div>
    <div class="alligned-field-cell">
      <span [innerText]="getData(field)" [style]="field.css" class="field-content"></span>
    </div>
  </div>
  }
  <!-- LINK -->
  @case ('link') {
  <div
    class="detail-field detail-field--responsive"
    [style.flex-basis]="(field.fxFlex || '33') + '%'"
    [style.max-width]="temp1 === 'column' ? null : (field.fxFlex || '33') + '%'"
  >
    <span [innerText]="getLabel(field)" class="field-headline"></span>
    @if (field.break === false) {
    <span>: </span>
    } @if (field.break !== false) {
    <span><br /></span>
    }
    <a [href]="getLink(field)" target="_blank">
      <span [innerText]="getData(field)" [style]="field.css" class="field-content"></span>
    </a>
  </div>
  }
  <!-- HTML -->
  @case ('html') {
  <div
    class="detail-field"
    [style.flex-basis]="(field.fxFlex || '33') + '%'"
    [style.max-width]="temp1 === 'column' ? null : (field.fxFlex || '33') + '%'"
  >
    <span [innerText]="getLabel(field)" class="field-headline"></span>
    @if (field.break === false) {
    <span>: </span>
    } @if (field.break !== false) {
    <span><br /></span>
    }
    <span [innerHTML]="getData(field)" [style]="field.css" class="field-content"></span>
  </div>
  }
  <!-- TEXTAREA -->
  @case ('textarea') {
  <div class="w-full">
    <span [innerText]="getLabel(field)" class="field-headline"></span>
    <p [innerText]="getData(field)" [style]="field.css" class="textarea"></p>
  </div>
  }
  <!-- CHAPTER -->
  @case ('chapter') {
  <div class="w-full d-flex flex-row gap-10">
    <div class="flex-1 hide-lt-sm" [style.padding-top.px]="22"><hr /></div>
    <div class="flex-initial" [style.color]="'var(--theme-accent-500)'">
      <h3 [innerHtml]="getLabel(field)"></h3>
    </div>
    <div class="flex-1" [style.padding-top.px]="22"><hr /></div>
  </div>
  }
  <!-- FILES -->
  @case ('files') { @if (field.label) {
  <h4 [innerText]="field.label"></h4>
  } @if (mandant=='telekom') {
  <p class="textbox">
    Bitte warten Sie 60 Sekunden und aktualisieren Sie den Browser (Strg + F5 oder über den Kreis
    neben der Adresszeile), damit Sie in dieser Dokumentensicht alle bereits hochgeladenen Dokumente
    sehen können. Wir arbeiten an einer besseren Lösung für Sie, wodurch die Verzögerung und das
    manuelle Laden der Seite entfallen kann.
  </p>
  }
  <div class="w-full" [style.margin-right.px]="-24">
    <div class="button-new-line d-flex flex-row gap-16">
      <div class="w-50 d-flex flex-column gap-16">
        @if (allowFileUpload) {
        <app-detail-file-upload [metadata]="getMetadata(field)"></app-detail-file-upload>
        }
      </div>
      <div class="w-50">
        @if (documents.length > 0) {
        <div class="file-list-container d-flex flex-column gap-16">
          @for (document of documents; track document; let i = $index) {
          <div class="file-container">
            <button
              mat-raised-button
              class="fileButton d-flex justify-start items-center"
              (click)="downloadFile(document, i)"
              [loading]="fileDownloadState[i] === true"
              [disabled]="fileDownloadState[i] === true"
            >
              <mat-icon>download</mat-icon>
              {{ document.name }}
            </button>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
  }
  <!-- TYPED-FILES -->
  @case ('typed-files') { @if (field.label) {
  <h4 [innerText]="field.label"></h4>
  } @if (mandant=='telekom') {
  <p class="textbox">{{ 'taskmodule.task.details.hint_text' | translate}}</p>
  }
  <div class="w-full d-flex flex-column gap-16 typed-files-row">
    <div class="typed-files-col">
      @if (allowFileUpload) {
      <app-detail-file-upload
        [documentTypes]="field.options!"
        [typeIsRequired]="field.typeIsRequired || false"
        [metadata]="getMetadata(field)"
        [readonly]="readonly"
      ></app-detail-file-upload>
      }
    </div>
    <div class="typed-files-col">
      @if (documents.length > 0) {
      <div class="file-list-container d-flex flex-column gap-16">
        @for (document of documents; track document; let i = $index) {
        <div>
          <div class="file-container">
            <button
              mat-raised-button
              class="fileButton d-flex justify-start items-center"
              [title]="document.name"
              (click)="downloadFile(document, i)"
              [loading]="fileDownloadState[i] === true"
              [disabled]="fileDownloadState[i] === true"
            >
              <mat-icon>download</mat-icon>
              {{ document.name}}
            </button>
          </div>
          <div>{{ document.changeDate | date: 'dd.MM.yyyy, HH:mm:ss' }}</div>
        </div>
        }
      </div>
      }
    </div>
  </div>
  }
  <!-- DATA GRID -->
  @case ('grid') {
  <div class="w-full">
    @if (field.columns && getTableData(field.key)) {
    <mtx-grid
      [toolbarTitle]="getLabel(field) || ''"
      [showToolbar]="true"
      [columns]="field.columns!"
      [data]="getTableData(field.key)"
      [showPaginator]="false"
      [columnMenuButtonText]="'grid.columns_shown' | translate"
      [columnMenuHeaderText]="'grid.columnMenuHeaderText' | translate"
    ></mtx-grid>
    }
  </div>
  } } } }
</div>
